import React from "react";
import Helmet from "react-helmet";

// https://mathiasbynens.be/notes/touch-icons
import favicon from "../assets/images/favicon.ico";
import favicon16 from "../assets/images/favicon_16x16.png";
import favicon32 from "../assets/images/favicon_32x32.png";
import icon72 from "../assets/images/app_icons/icon-72.png";
import icon76 from "../assets/images/app_icons/icon-76.png";
import iconSmallRetina from "../assets/images/app_icons/icon-small@2x.png";
import icon60retina from "../assets/images/app_icons/icon-60@2x.png";
import icon72retina from "../assets/images/app_icons/icon-72@2x.png";
import icon76retina from "../assets/images/app_icons/icon-76@2x.png";
import icon60triple from "../assets/images/app_icons/icon-60@3x.png";
import icon192 from "../assets/images/app_icons/192.png";

export default function CalHelmet() {
  return (
    <Helmet>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta
        name="description"
        content="CalCentral is a new resource for the UC Berkeley community."
      />

      {/* Set a web app capable website */}
      <meta name="apple-mobile-web-app-capable" content="no" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-title" content="CalCentral" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black" />

      <link href={iconSmallRetina} rel="apple-touch-icon" />
      <link href={icon72} rel="apple-touch-icon" sizes="72x72" />
      <link href={icon76} rel="apple-touch-icon" sizes="76x76" />
      <link href={icon60retina} rel="apple-touch-icon" sizes="120x120" />
      <link href={icon72retina} rel="apple-touch-icon" sizes="144x144" />
      <link href={icon76retina} rel="apple-touch-icon" sizes="152x152" />
      <link href={icon60triple} rel="apple-touch-icon" sizes="180x180" />
      <link href={icon192} rel="icon" sizes="192x192" />
      <link
        href={favicon}
        rel="shortcut icon"
        type="image/vnd.microsoft.icon"
      />
      <link href={favicon16} rel="icon" sizes="16x16" type="image/png" />
      <link href={favicon32} rel="icon" sizes="32x32" type="image/png" />
    </Helmet>
  );
}
